import React from 'react';

var Utils = {

    setAtts(ref, atts){
        if(ref) {
            Object.keys(atts).forEach( (key)=>{
                ref.setAttribute(key, atts[key]);
            });
        }
    },
    //Limit a string to a given length
    limitTo(str, lim) {
        str = str || '';
        var endIndex = Math.min(lim,str.length); 
        return str.substring(0,endIndex);
    },
    //Convert string to title case
    titleCase(str) {
        if(str) {
            var tokens = str.split(/\s+/);
            return tokens.map(token => (token.charAt(0).toUpperCase() + token.slice(1))).join(' ');
        } else {
            return '';
        }
    },
    padZeros(str, length) {
        var numZeros = length - str.length;
        for(var i = 0; i < numZeros; i++) {
            str = "0" + str;
        }
        return str;
    },
    //deep set an object, create new sub objects along the way if null
    set(o, path, val) {
        var result = o;
        var keys = path.split('.');
        var lastKey = keys.pop();
        while(keys.length > 0) {
            var nextKey = keys.shift(); 
            var next = result[nextKey];
            if((typeof next==='object' && next!==null)===false) {
                next = {}
                result[nextKey] = next;
            }
            result = next;
        }
        result[lastKey] = val;
        return o;
    },
    //deep dereference an object, provide a default value if a null is encountered along the way
    deref(o, path, def) {
        var result = o;
        var keys = path.split('.');
        var lastKey = keys.pop();
        var end = (typeof result==='object' && result!==null)===false;
        while(keys.length > 0 && !end) {
            var nextKey = keys.shift(); 
            result = result[nextKey];
            end = (typeof result==='object' && result!==null)===false;
        }
        return end ? def : result[lastKey];
    },
    delay(ms) {
		return new Promise(function(resolve, reject) {
            setTimeout(()=>{ resolve(); }, ms);
	    });
    },
    getPercent(val, total) {
        return ((val*100.0)/total); 
    },
    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    url(src) { //wrap image src in url for css background
        return (src && src.length) ? 'url("'+src+'")' : '';
    },
    endlToBr(text) { //convert text with endlines into array of spans ending with br
        return ((text||'').split('\n')
                          .map((item, key) => (
                                React.createElement(
                                  "span",
                                  { key: key },
                                  item,
                                  React.createElement("br", null)
                                ))));
    },
    supportsVideoCapture() {
        return navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
    },
    getHref(href) {//Ensure href has a protocol.
        if(href===undefined || href===null) {
            return undefined;
        }
        href = href.trim();
        if(href==='') {
            return undefined;
        }
        if(href.startsWith('http')) {
            return href;
        }
        return "http://" + href;
    },
    getScrollPosition() {
        var result = {top:  window.pageYOffset || document.documentElement.scrollTop,
                      left: window.pageXOffset || document.documentElement.scrollLeft};
        return result;
    },
    _scrollPositions: [],
    pushScrollPosition() {
        this._scrollPositions.push(this.getScrollPosition());
    },
    popScrollPosition() {
        var sp = this._scrollPositions.pop() || {top:0, left:0};
        window.scrollTo(sp.left, sp.top);
    }
};

export default Utils;



// WEBPACK FOOTER //
// ./src/utils/Utils.js